var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTakesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1377 15.125V17.05",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5542 20.1667H15.7209V19.2501C15.7209 18.2417 14.8959 17.4167 13.8875 17.4167H8.38753C7.3792 17.4167 6.5542 18.2417 6.5542 19.2501V20.1667V20.1667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6377 20.1667H16.6377",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 14.6666C7.45266 14.6666 4.5835 11.7974 4.5835 8.24992V5.49992C4.5835 3.47409 6.22433 1.83325 8.25016 1.83325H13.7502C15.776 1.83325 17.4168 3.47409 17.4168 5.49992V8.24992C17.4168 11.7974 14.5477 14.6666 11.0002 14.6666Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01428 10.6792C4.32678 10.4592 3.72178 10.0559 3.24512 9.57922C2.42012 8.66255 1.87012 7.56255 1.87012 6.27922C1.87012 4.99588 2.87845 3.98755 4.16178 3.98755H4.75762C4.57428 4.40922 4.48262 4.87672 4.48262 5.36255V8.11255C4.48262 9.02922 4.67512 9.89088 5.01428 10.6792Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9858 10.6792C17.6733 10.4592 18.2783 10.0559 18.755 9.57922C19.58 8.66255 20.13 7.56255 20.13 6.27922C20.13 4.99588 19.1217 3.98755 17.8383 3.98755H17.2425C17.4258 4.40922 17.5175 4.87672 17.5175 5.36255V8.11255C17.5175 9.02922 17.325 9.89088 16.9858 10.6792Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakesIcon);
export default __webpack_public_path__ + "static/media/takesIcon.64f8ae6e385ac011f9d311a08bd9e2c7.svg";
export { ForwardRef as ReactComponent };